import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  adjustmentActivity: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  activityContent: {
    background: 'transparent',
    boxShadow: 'none',
  },
  activityShowing: {
    fontWeight: 400,
    fontSize: pxToRem(12),
    color: theme.palette.neutralSecondary,
    selectors: {
      '& span': {
        fontWeight: 600,
      },
    },
  },
  showMoreActivity: {
    fontSize: pxToRem(14),
    cursor: 'pointer',
    marginTop: pxToRem(14),
    color: theme.palette.themePrimary,
  },
  showMoreActivityButton: {
    float: 'right',
    selectors: {
      '&:hover': {
        color: theme.palette.themePrimary,
        textDecoration: 'none',
      },
    },
  },
});
